import FlowEditor from "./FlowEditor"
import logo from '../../logo.png';
import { Selector } from "../common/Selector";
import { useCallback, useEffect, useState } from "react";
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from 'react-router-dom';
import { docVisited, fetchFlowDocs, getAppConfig, getUserInfo, trashDoc, upsertDoc } from "@/actions/ticketAction";
import { getState } from "@/reducers/listReducer";
import { ChevronRight, KeyboardReturn } from '@styled-icons/material';
import { APP_CONFIG, FLOW_INPUT_MODAL, FLOW_MODAL, INVITED_CODE } from "@/constants/actionTypes";
import SettingsModal from "../SettingsModal";
import { Tooltip } from '@mui/material';
import { PromptModal } from "../settings/PromptModal";
import { ImageUploadModal } from "../common/ImageUploadModal";
import { useMediaQuery } from 'react-responsive';
import { getCurrentBrowserFingerPrint } from "@rajesh896/broprint.js";
import InviteFriendsModal from "../feedbacks/InviteFriendsModal";
import GlobalDndContext from "../DndContext";
// import googleOneTap from "google-one-tap";
import { GoogleLogin } from "../../views/pages/login/GoogleLogin";
import { LlmAPIKeyModal } from "../settings/LlmAPIKeyModal";
import { EditableMenuItemActions } from "./EditableMenuItemActions";
import { Menu } from '@styled-icons/material/Menu';
import ReactGA from "react-ga4";
import { MOBILE_MEDIA_QUERY } from "../../utils/constants";
import FlowGuide from "./FlowGuide";
import ConfirmDialog from "../ConfirmDialog";
import ExportModal from "../header/ExportModal";
import { PROMPT_DIALOG } from "../../constants/actionTypes";
import { getPrompt } from "../../actions/ticketAction";
import { Plus } from "@styled-icons/bootstrap";
import Profile from "../sidebar/Profile";
import { getStateByUser } from "../../reducers/listReducer";
import PromoteVIP from "../settings/PromoteVIP";
import { PromoteModal } from "../common/PromoteModal";
import * as types from '../../constants/actionTypes';

let lng = navigator.language || navigator.userLanguage

if (lng && lng.indexOf('zh-') > -1) {
    lng = 'cn'
}

if (lng != 'cn') {
    lng = 'en'
}

const BOARD_TITLE_WIDTH = 300;

const Mindmax = () => {
    const intl = useIntl();
    const history = useHistory();
    const dispatch = useDispatch();
    const loginUser = useSelector(state => state.loginIn.user);
    const flow_doc_lists = useSelector(state => getState(state.flow_doc_lists, loginUser.workingOrgId));
    const promote_vip = useSelector(state => state.uiState.promote_vip) || {};
    const orgs = useSelector(state => getStateByUser(state.org_lists, loginUser));

    const show_sidebar_with_aiflow = useSelector(state => state.uiState.show_sidebar_with_aiflow);

    const location = useLocation();
    const params = new Proxy(new URLSearchParams(location.search), {
        get: (searchParams, prop) => searchParams.get(prop) || '',
    });

    const { hid, queryType, userInput, action, nodeType, title, content, src, url, promptId } = params;
    const uiLng = useSelector(state => state.uiState.lng) || lng || 'en';
    const inviteCode = useSelector(state => state.uiState.invited_code)
    const [boards, setBoards] = useState([]);
    const [board, setBoard] = useState('');
    const [initNodeData, setInitNodeData] = useState();
    const [itemTrashed, setItemTrashed] = useState();

    const isMobile = useMediaQuery(MOBILE_MEDIA_QUERY);

    useEffect(() => {
        dispatch(getAppConfig({ service: 'funblocks' }, (data) => {
            dispatch({
                type: APP_CONFIG,
                value: data
            })
        }));
    }, [])

    useEffect(() => {
        // ReactGA.initialize(GOOGLE_ANALYTICS_TRACKID);
        ReactGA.send({ hitType: "pageview", page: "/aiflow", title: "Mindmap" });
    }, [])

    useEffect(() => {
        if (params?.inviteCode) {
            dispatch({
                type: INVITED_CODE,
                value: params.inviteCode
            })
        }
    }, [params?.inviteCode])

    useEffect(() => {
        //Already funblocks user, no reward.
        if (!!loginUser?._id || !params?.inviteCode) {
            return;
        }

        getCurrentBrowserFingerPrint().then((fingerprint) => {
            if (fingerprint == params?.fp) {
                return;
            }

            // 延时 3 秒
            const timer = setTimeout(() => {
                // 将访问者信息发送到服务器
                dispatch(docVisited({
                    hid: params.hid,
                    inviteCode: params.inviteCode,
                    fingerprint
                }, (award) => {
                }))
            }, 3000);

            // 清理延时器
            return () => clearTimeout(timer);

        })
    }, [params?.inviteCode])

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                dispatch(getUserInfo());
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);
    
    useEffect(() => {
        if (hid || loginUser?._id || !uiLng || nodeType || queryType || initNodeData) return;

        const currentUrl = new URL(window.location.href);
        let toHid;

        // if (loginUser?._id) {
        //     toHid = '';
        // } else if (source != 'flow') {
        toHid = 'welcome_to_aiflow_' + uiLng;
        // }

        // if (!toHid) {

        // } else {
        if (currentUrl.hash) {
            const hashParts = currentUrl.hash.split('?');

            const hashSearchParams = new URLSearchParams(hashParts[1] || '');

            if (!hashSearchParams.has('hid')) {
                hashSearchParams.append('hid', toHid);
            }

            currentUrl.hash = hashParts[0] + '?' + hashSearchParams.toString();
        } else {
            currentUrl.hash = '#/aiflow?hid=' + toHid;
        }
        // }

        window.history.replaceState({}, '', currentUrl);
        window.location.reload()
    }, [uiLng])


    return <div style={{ position: 'relative', touchAction: 'none' }} className="fill-available">
        <GlobalDndContext>
            <FlowEditor
                appSideBarHidden={true}
                standAlone={true}
                initNodeData={initNodeData}
            />
        </GlobalDndContext>
        <SettingsModal />
        {/* <PromptModal /> */}
        <LlmAPIKeyModal />
        <InviteFriendsModal />
        <ExportModal />
        <ConfirmDialog />
        {/* <PromoteModal /> */}
        {/* <ImageUploadModal isMobile={isMobile} />

        {
            !(loginUser?._id || window.self !== window.top) &&
            <GoogleLogin showButton={false} inviteCode={inviteCode} />
        } */}
        <FlowGuide />
    </div>
}

export default Mindmax